exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-width[data-v-0b9f0552]{width:200px}.form-height[data-v-0b9f0552]{height:93%}.distribute-btn[data-v-0b9f0552]{height:40px;line-height:40px}.config-title[data-v-0b9f0552]{border-left:2px solid #3686ef;font-size:18px}", ""]);

// exports
